import { User, UserManager } from 'oidc-client-ts'
import { createContext } from 'react'

export interface IAuthContext {
  user: User | null
  isAuthenticated: boolean
  isLoading: boolean
  login: () => Promise<void>
  logout: () => Promise<void>
  getAccessToken: () => string | null
  userManager: UserManager
}

export const AuthContext = createContext<IAuthContext | undefined>(undefined)
